import React, { ReactElement } from 'react';
import { NoIndexProps } from '../types';

export const NoIndex = ({ seo }: NoIndexProps): ReactElement | null => {
  if (seo?.noindex === true) {
    return <meta name="robots" content="noindex" />;
  }

  return null;
};
